module.exports = __webpack_public_path__ + "img/6.cd16dafc.jpg";